import { Inbox } from "lucide-react";
import type { ModuleSpec } from "../types";

export const conversationsSpec: ModuleSpec = {
  id: "conversations",
  icon: Inbox,
  i18n: {
    namespace: "modules",
    titleKey: "conversations.title",
    descriptionKey: "conversations.description",
  },
  nav: {
    path: "/conversations",
    group: "run",
    order: 20,
  },
  permission: {
    action: "read",
    subject: "conversation",
  },
  meta: {
    status: "active",
    description: "Manage customer conversations",
  },
};
